<template>
  <div class="control-alarmlist" :class="{ 'control-list-show': isShow }">
    <div class="control-list-panel flex-valign">
      <div class="list-search flex-between valign-center map-blur-panel__title">
        <div class="search-select flex-between">
          <!-- <el-select
            clearable
            placeholder="全部级别"
            v-model="searchForm.alarmLevel"
            @change="handleChangeSearch"
          >
            <el-option
              v-for="item in alarmLevels"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select> -->
          <!-- <el-cascader
    v-model="value"
    :options="options"
    :props="{ expandTrigger: 'hover' }"
    @change="handleChange"></el-cascader> -->

          <el-cascader
            :title="typeLabel"
            clearable
            v-model="searchForm.commonAlarmType"
            ref="cascaderPanel"
            placeholder="全部类型"
            :show-all-levels="false"
            :options="cascaderOptions"
            @change="handleChangeSearch"
            :props="cascaderProps"
          ></el-cascader>
          <!-- <el-select
           
            v-model="searchForm.commonAlarmType"
            @change="handleChangeSearch"
            clearable
          >
            <el-option
              v-for="item in alarmTypes"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select> -->
          <el-select
            @change="handleChangeSearch"
            v-model="searchForm.alarmState"
            placeholder="全部状态"
            clearable
          >
            <el-option
              v-for="item in alarmStatus"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="point-icon iconfont-lunan icon-lunan-gengduoda"
          style="margin-right: 6px; z-index: 2; color: #000000;"
          @click.stop="searchFormShow = !searchFormShow"
        ></div>
        <el-collapse-transition>
          <div
            class="list-search_form"
            v-if="searchFormShow"
            @click.stop="stopPropagation"
          >
            <el-form :model="searchForm" label-width="100px">
              <el-form-item label="告警名称：">
                <el-input
                  v-model="searchForm.alarmName"
                  @click.stop.native="stopPropagation"
                  placeholder="请输入告警名称"
                  clearable
                  class=""
                ></el-input>
              </el-form-item>
              <el-form-item label="时间范围：">
                <el-date-picker
                  style="width: 100%"
                  v-model="searchForm.alarmTime"
                  type="datetimerange"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :start-placeholder="$t('realTimeAlarm.placeholder.startTime')"
                  :end-placeholder="$t('realTimeAlarm.placeholder.endTime')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label-width="0px" class="text-right">
                <el-button @click="reset" type="info">重置</el-button>
                <el-button type="primary" @click="handleQuery">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";
export default {
  name: "alarm-control-left",
  props: {},
  computed: {
    typeLabel() {
      if (this.searchForm.commonAlarmType) {
        return this.$refs.cascaderPanel && this.$refs.cascaderPanel.inputValue;
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      isShow: true,
      expandType: true,
      cascaderOptions: [],
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        expandTrigger: "hover",
      },
      searchForm: {
        alarmLevel: "", //等级
        commonAlarmType: [], //类型
        alarmState: "", //状态
        alarmName: "", //告警名称
        alarmTime: [], //告警时间
      },
      searchFormShow: false,
      alarmLevels: Dic.find("SENU017"), //告警等级
      // alarmStatus: Dic.find("SENU068").filter((el) => {
      //   return el.value == 1 || el.value == 4 || el.value == 5 || el.value == 6 || el.value == 10;
      // }), //告警状态
      alarmStatus: Dic.find("SENU068").filter((el) => {
        return el.value == 1 || el.value == 4 || el.value == 10;
      }), //告警状态
      alarmTypes: Dic.find("SENU097003001"), //告警类型
    };
  },
  created() {
    this.getAlarmTypeAndSubsystem();
  },
  mounted() {
    document.addEventListener("click", this.domClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.domClick);
  },
  methods: {
    //获取系统类型数据
    getAlarmTypeAndSubsystem() {
      const self = this;
      // 实时告警页面系统类型去除消防子系统和电器火灾
      this.$fetch(api.bas.getAlarmTypeAndSubsystem, {}).then((response) => {
        let subList = [];
        response.returnObj.forEach((item, index) => {
          if (item.id != "4" && item.id != "13" && item.id != "14") {
            subList.push(item);
          }
        });
        self.cascaderOptions = [...subList];
      });
    },
    handleChangeSearch() {
      // console.log(this.searchForm);
      this.handleQuery();
    },
    stopPropagation() {
      // 阻止冒泡
    },
    // 收起弹窗
    domClick() {
      this.searchFormShow = false;
    },
    handleQuery() {
      this.searchFormShow = false;
      let params = { ...this.searchForm };
      this.$emit("handleSearch", params);
    },
    reset() {
      this.searchFormShow = false;
      this.searchForm.alarmName = "";
      this.searchForm.alarmTime = [];
      this.searchForm.alarmState = "";
      this.searchForm.commonAlarmType = [];
      this.handleQuery();
    },
  },
};
</script>
<style lang="scss">
@import "../style/control-left.scss";
.search-select {
  align-items: center;
  // .el-input__inner {
  //   background: #202631 !important;
  //   border: none !important;
  //   height: 39px;
  // }
}
</style>
